export const BASE_URL = 'http://192.168.0.126/projectxs/api'